<template>
  <div class="home-box">
    <el-container class="home-box">
      <el-header id="nav-fixed" :class="{ nav_fixed: isFixed }">
        <TopMenu></TopMenu>
      </el-header>
      <el-container class="nav-top">
        <el-aside width="auto">
          <LeftMenu></LeftMenu>
        </el-aside>
        <el-main>
          <div style="background:white;height:100%" class="home-main-body">
            <router-view :key="key" />
          </div>
          <!-- <el-container
            :class="path != '/index' ? 'home-content' : 'home-index'"
          >
            <el-header class="header" height="auto">
              <div v-if="tabPosition === 'top'" style="padding: 0px 0px">
                <el-tabs
                  v-if="showTabs"
                  ref="tabs"
                  :value="tabName"
                  :type="tabType"
                  @tab-click="onTabClick"
                  @tab-remove="onRemoveTab"
                  @contextmenu.prevent.native="onOpenMenu"
                >
                  <el-tab-pane
                    v-for="tab in tabsList"
                    :key="tab.path"
                    :name="tab.path"
                    :label="tab.meta.title"
                    :closable="tab.path !== '/zonghe'"
                  >
                    <template #label  >
                      <span>
                        {{ tab.meta.title }}
                      </span>
                    </template>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-header>
            <el-main class="main" style="height: 100%">
              <router-view v-if="isDev" :key="key" />
              <keep-alive v-else>
                <router-view :key="key" />
              </keep-alive>
            </el-main>
            <ul
              v-if="tabPosition === 'top'"
              v-show="rightMenu.visible"
              ref="rightMenu"
              :style="{
                left: rightMenu.left + 'px',
                top: rightMenu.top + 'px',
              }"
              class="contextmenu"
            >
              <li @click="refreshCurrentTab">
                <i class="el-icon-refresh-right" />刷新
              </li>
              <el-divider
                v-if="
                  canClose ||
                  canCloseOthers ||
                  canCloseRight ||
                  canCloseLeft ||
                  canCloseAll
                "
              />
              <li v-if="canClose" @click="closecurrentTab">
                <span>关闭</span>
              </li>
              <li v-if="canCloseOthers" @click="closeOthersTabs">
                <i class="el-icon-more" />关闭其它
              </li>
              <li v-if="canCloseRight" @click="closeRightTabs">
                <i class="el-icon-right" />关闭到右侧
              </li>
              <li v-if="canCloseLeft" @click="closeLeftTabs">
                <i class="el-icon-back" />关闭到左侧
              </li>
              <li v-if="canCloseAll" @click="closeAllTabs">
                <span>关闭所有</span>
              </li>
            </ul>
            <el-footer v-if="tabPosition === 'bottom'" class="footer" height>
              <el-tabs
                v-if="showTabs"
                ref="tabs"
                :value="tabName"
                :type="tabType"
                :tab-position="tabPosition"
                @tab-click="onTabClick"
                @tab-remove="onRemoveTab"
                @contextmenu.prevent.native="onOpenMenu"
              >
                <el-tab-pane
                  v-for="tab in tabsList"
                  :key="tab.path"
                  :name="tab.path"
                  :label="tab.meta.title"
                  :closable="tab.path !== '/zonghe'"
                >
                  <template #label>
                    <span>
                      {{ tab.meta.title }}
                    </span>
                  </template>
                </el-tab-pane>
              </el-tabs>
            </el-footer>
            <ul
              v-if="tabPosition === 'bottom'"
              v-show="rightMenu.visible"
              ref="rightMenu"
              :style="{
                left: rightMenu.left + 'px',
                top: rightMenu.top + 'px',
              }"
              class="contextmenu"
            >
              <li v-if="canCloseAll" @click="closeAllTabs">
                <span>关闭所有</span>
              </li>
              <li v-if="canCloseLeft" @click="closeLeftTabs">
                <i class="el-icon-back" />关闭到左侧
              </li>
              <li v-if="canCloseRight" @click="closeRightTabs">
                <i class="el-icon-right" />关闭到右侧
              </li>
              <li v-if="canCloseOthers" @click="closeOthersTabs">
                <i class="el-icon-more" />关闭其它
              </li>
              <li v-if="canClose" @click="closecurrentTab">
                <span>关闭</span>
              </li>
              <el-divider
                v-if="
                  canClose ||
                  canCloseOthers ||
                  canCloseRight ||
                  canCloseLeft ||
                  canCloseAll
                "
              />
              <li @click="refreshCurrentTab">
                <i class="el-icon-refresh-right" />刷新
              </li>
            </ul>
          </el-container> -->
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import TopMenu from "./topMenu.vue";
import LeftMenu from "./leftMenu.vue";
import Sortable from "sortablejs";
import Bread from "./bread.vue";
if (!Element.prototype.closest) {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  Element.prototype.closest = function (s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement;
    } while (el !== null);
    return null;
  };
}

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.path = to.path;
    });
  },
  data() {
    return {
      isFixed: false,
      offsetTop: 0,
      path: "",
      tabsList: [],
      rightMenu: {
        top: 0,
        left: 0,
        visible: false,
        selectedTab: {},
      },
      tabPosition: "top", // top | bottom
      tabType: "border-card", // '' | border-card | card
    };
  },
  components: {
    LeftMenu,
    TopMenu,
    Bread,
  },
  computed: {
    key() {
      const tabs = this.$store.getters.tabsList;
      const fullPath = this.$route.fullPath;
      const tab = tabs && tabs.find((t) => t.fullPath === fullPath);
      const k = tab && tab._k ? tab._k : "";

      return this.$route.fullPath + k;
    },
    showTabs() {
      return this.tabsList.length > 0;
    },
    tabName() {
      return this.$route.path;
    },
    canClose() {
      return (
        this.rightMenu.selectedTab.meta &&
        this.rightMenu.selectedTab.meta.closable
      );
    },
    canCloseOthers() {
      const tabIndex = this.tabsList.findIndex(
        (t) => t.fullPath === this.rightMenu.selectedTab.fullPath
      );
      return (
        (tabIndex === 0 && this.tabsList.length > 1) ||
        (tabIndex > 0 && this.tabsList.length > 2)
      );
    },
    canCloseRight() {
      const tabIndex = this.tabsList.findIndex(
        (t) => t.fullPath === this.rightMenu.selectedTab.fullPath
      );
      return this.tabsList.length - 1 > tabIndex;
    },
    canCloseLeft() {
      const hasHome = this.tabsList.findIndex((t) => t.fullPath === "/") >= 0;
      const tabIndex = this.tabsList.findIndex(
        (t) => t.fullPath === this.rightMenu.selectedTab.fullPath
      );
      return tabIndex > (hasHome ? 1 : 0);
    },
    canCloseAll() {
      return this.tabsList.length > 1;
    },
    isDev() {
      return process.env.NODE_ENV === "development";
    },
  },
  watch: {
    $route() {
      this.addTab();
    },
    "rightMenu.visible"(value) {
      if (value) {
        document.body.addEventListener("click", this.closeRightMenu);
      } else {
        document.body.removeEventListener("click", this.closeRightMenu);
      }
    },
    tabsList() {
      this.$store.commit("saveTabsData", JSON.stringify(this.tabsList));
    },
  },
  async created() {
    this.addTab();
  },
  updated() {
    this.setSort();
  },
  methods: {
    // 点击选项卡
    onTabClick(tab) {
      if (tab.name && tab.name !== this.tabName) {
        this.$router.push(tab.name);
      }
    },
    // 添加标签
    addTab() {
      const route = this.$route;
      if (!route.meta.title || route.meta.noTab) {
        return;
      }

      const exists = this.tabsList.some((item) => item.path === route.fullPath);
      if (exists) {
        return;
      }
      // 获取视图缓存名
      const matchedIndex = route.matched && route.matched.length - 1;
      let name =
        matchedIndex >= 0 &&
        route.matched[matchedIndex].components.default.name;
      name = name || route.name;

      const tab = {
        name: name,
        path: route.path,
        fullPath: route.fullPath,
        meta: { ...route.meta },
      };

      if (tab.path === "/") {
        this.tabsList.unshift(tab);
      } else {
        this.tabsList.push(tab);
      }
    },
    // 关闭选项卡
    onRemoveTab(targetPath) {
      console.log(targetPath);
      this.rightMenu.visible = false;
      const index = this.tabsList.findIndex((tab) => tab.path === targetPath);
      this.tabsList.splice(index, 1)[0];
      const toTab = this.tabsList[index]
        ? this.tabsList[index]
        : this.tabsList[index - 1];
      if (toTab) {
        targetPath === this.$route.fullPath && this.$router.push(toTab.path);
      } else {
        this.$router.push("/zonghe");
      }
    },
    // tab打开右键菜单
    onOpenMenu(e) {
      const $tab = e.target.closest(".el-tabs__item");
      if ($tab) {
        const id = $tab.getAttribute("id");
        const path = id.replace(/^tab-/, "");
        this.rightMenu.selectedTab = this.tabsList.find(
          (t) => t.fullPath === path
        );
        this.rightMenu.visible = true;
        const menuMinWidth = 132;
        const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
        const offsetWidth = this.$el.offsetWidth; // container width
        const maxLeft = offsetWidth - menuMinWidth; // left boundary
        const left = e.clientX - offsetLeft + 0; // 15: margin right

        if (left > maxLeft) {
          this.rightMenu.left = maxLeft;
        } else {
          this.rightMenu.left = left;
        }

        this.$nextTick(() => {
          if (this.tabPosition === "bottom") {
            this.rightMenu.top = e.clientY - this.$refs.rightMenu.offsetHeight;
          } else if (this.tabPosition === "top") {
            this.rightMenu.top = e.clientY + 25;
          }
        });
      }
    },
    // tab拖拽排序
    setSort() {
      const _this = this;
      if (!this.$refs.tabs) {
        return;
      }
      const el = this.$refs.tabs.$el.querySelector('[role="tablist"]');
      Sortable.create(el, {
        ghostClass: "", // Class name for the drop placeholder,
        draggable: '[role="tab"]:not([id="tab-/"])', // Specifies which items inside the element should be draggable
        // animation: 150,
        setData: function (dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        onEnd: (evt) => {
          if (this.tabType === "border-card") {
            const targetTab = _this.tabsList.splice(evt.oldIndex, 1)[0];
            _this.tabsList.splice(evt.newIndex, 0, targetTab);
          } else {
            const targetTab = _this.tabsList.splice(evt.oldIndex - 1, 1)[0];
            _this.tabsList.splice(evt.newIndex - 1, 0, targetTab);
          }
        },
      });
    },
    // 关闭tab右键菜单
    closeRightMenu() {
      this.rightMenu.visible = false;
    },
    refreshCurrentTab() {
      this.$router.go(0);
    },
    closecurrentTab() {
      this.rightMenu.selectedTab &&
        this.onRemoveTab(this.rightMenu.selectedTab.fullPath);
    },
    closeOthersTabs() {
      const tab = this.rightMenu.selectedTab;
      const tabIndex = this.tabsList.findIndex(
        (t) => t.fullPath === tab.fullPath
      );
      if (tabIndex === 0) {
        this.tabsList = [tab];
      } else {
        this.tabsList = [this.tabsList[0], tab];
      }
      this.$router.push(tab.fullPath);
    },
    closeAllTabs() {
      const tab = this.tabsList.find((t) => t.fullPath === "/");
      this.tabsList = tab ? [tab] : [];
      this.$router.push("/");
    },
    closeRightTabs() {
      const selectedPath = this.rightMenu.selectedTab.fullPath;
      const tabIndex = this.tabsList.findIndex(
        (t) => t.fullPath === selectedPath
      );
      this.tabsList = this.tabsList.slice(0, tabIndex + 1);
      const toTab = this.tabsList[this.tabsList.length - 1];
      if (toTab) {
        selectedPath !== this.$route.fullPath && this.$router.push(toTab.path);
      } else {
        this.$router.push("/");
      }
    },
    closeLeftTabs() {
      const selectedPath = this.rightMenu.selectedTab.fullPath;
      const tabIndex = this.tabsList.findIndex(
        (t) => t.fullPath === selectedPath
      );
      const tab = this.tabsList.find((t) => t.fullPath === "/");
      this.tabsList = tab
        ? [tab, ...this.tabsList.slice(tabIndex)]
        : [...this.tabsList.slice(tabIndex)];
      const toTab = this.tabsList[this.tabsList.length - 1];
      if (toTab) {
        selectedPath !== this.$route.fullPath && this.$router.push(toTab.path);
      } else {
        this.$router.push("/");
      }
    },
  },
  beforeCreate: function () {
    //可以在这加个loading事件
    //console.group('beforeCreate 创建前状态===============》');
  },
  created: function () {
    //在这结束loading，还做一些初始化，实现函数自执行
    //console.group('created 创建完毕状态===============》');
  },
  beforeMount: function () {
    //console.group('beforeMount 挂载前状态===============》');
  },
  mounted: function () {
    let sessionStorageTabs = sessionStorage.getItem("tabs");
    sessionStorageTabs = sessionStorageTabs
      ? JSON.parse(sessionStorageTabs)
      : [];
    if (sessionStorageTabs && sessionStorageTabs.length > 0) {
      this.tabsList = sessionStorageTabs;
    }
    //在这发起后端请求，拿回数据，配合路由钩子做一些事情
    //console.group('mounted 挂载结束状态===============》');
    // 设置bar浮动阈值为 #fixedBar 至页面顶部的距离
    // this.offsetTop = document.querySelector("#nav-fixed").offsetTop;
    // 开启滚动监听
    // window.addEventListener("scroll", this.handleScroll);
  },
  beforeUpdate: function () {
    //console.group('beforeUpdate 更新前状态===============》');
  },
  updated: function () {
    //console.group('updated 更新完成状态===============》');
  },
  beforeDestroy: function () {
    // 你确认删除XX吗？  当前组件已被删除，清空相关内容
    //console.group('beforeDestroy 销毁前状态===============》');
  },
  destroyed: function () {
    //console.group('destroyed 销毁完成状态===============》');
    // 离开页面 关闭监听 不然会报错
    //  window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>


<style lang="scss" scoped>
.home-box {
  height: 100%;
  overflow-y: auto;
  background-color: #f1f1f1;
}

/deep/.el-tabs__content {
  padding: 0 !important;
}

.el-header {
  padding: 0;
}

/* 侧边栏颜色 */
.el-aside {
  position: relative;
  min-height: 100%;
  overflow: hidden;
  padding-top: 15px;
  // background-color: #2d333e;
  background-color: #fff;
}

.el-aside::after {
  content: "";
  position: absolute;
  z-index: 111;
  top: 0;
  right: -20px;
  width: 15px;
  height: 100%;
  // box-shadow: 0px 4px 15px 4px rgba(131, 135, 142, 0.18);
}

.el-main {
  padding: 10px;
  background: #EFF3F6;
}

/*修改滚动条样式*/
.el-main::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}

.el-main::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}

.el-main::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}

.home-content {
  padding: 5px;
  width: 100%;
  height: calc(100vh - 4.5em);
  box-sizing: border-box;
}

.home-index {
  padding: 5px;
  width: 100%;
  height: calc(100vh - 60px);
  box-sizing: border-box;
}

.home-main {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}

.nav_fixed {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
}

#nav-fixed {
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}

.nav-top {
  margin-top: 60px;
  height: 100%;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
.container ::v-deep .el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: unset;
}

.header {
  z-index: 1;
  display: none;
}

.footer {
  padding: 0px;
  overflow: hidden;
}

.el-breadcrumb {
  line-height: 50px !important;
}

.navbar ::v-deep {

  .el-breadcrumb__inner,
  .el-breadcrumb__separator {
    color: #f4f4f5;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    color: #ffffff;
  }

  .el-dropdown {
    color: #ffffff;
  }
}
</style>

<style lang="scss" scoped>
.contextmenu {
  margin: 0;
  background: #ffffff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  min-width: 130px;

  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;

    &:hover {
      background: #eeeeee;
    }

    i {
      margin-right: 8px;
      font-size: 14px;
      vertical-align: -1px;
    }

    span {
      margin-left: 22px;
    }
  }

  .el-divider--horizontal {
    margin: 5px 0px;
  }
}

.user-avatar {
  margin: 7px 8px 7px 0;
  vertical-align: top;
  background-color: transparent;
}
</style>

<style>
@media screen and (max-width: 680px) {
  .collapsedLogo {
    display: none;
  }

  .el-dialog {
    width: 90% !important;
  }

  .content-expanded {
    max-width: 100% !important;
    max-height: calc(100% - 80px);
  }

  .el-menu--collapse {
    width: 100% !important;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner,
  .el-cascader.el-cascader--medium {
    width: 100% !important;
  }

  .el-message-box {
    width: 80%;
  }
}</style>